<!--
    主页面容器
    功能：主页面容器
-->
<template>
  <el-container
    :class="{
      'app-webview': $store.state.from === 'client' || $store.state.from === 'schoolCenter',
      'client-theme': $store.state.from === 'client',
      'school-center-theme': $store.state.from === 'schoolCenter',
      'show-full': $store.state.showFull}"
    class="main"
  >
    <el-aside width="200px">
      <MainMenu/>
    </el-aside>
    <el-main>
      <div class="main-content">
        <MainHeader/>
        <page-header
          v-if="$route.path !== '/'"
          :title="this.$route.meta.title"/>
        <el-breadcrumb
          separator="/"
          class="app-webview-bread">
          <el-link
            :underline="false"
            @click="goBack">
            <i class="el-icon-arrow-left"/>
            返回
          </el-link>
          <el-breadcrumb-item
            v-for="(item, index) in breadList"
            :key="index">
            {{ item.meta.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div
          v-if="$route.path === '/'"
          class="index_content">
          <page-header title="校区基本信息"/>
          <div class="main-body">
            <DepartmentInfo />
          </div>
        </div>
        <router-view class="main-body"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
/**
 * @overview 主页面容器
 */

import { token } from '@/utils';
import MainHeader from './Header';
import MainMenu from './Menu';
import DepartmentInfo from './info';

export default {
  name: 'Main',

  components: {
    MainHeader,
    MainMenu,
    DepartmentInfo,
  },
  data() {
    return {
      breadList: [],
      itBread: [],
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      this.breadList = [];
      this.name = this.$route.name;
      this.$route.matched.forEach((item) => {
        this.breadList.push(item);
      });

      const itList = [];
      const itMatched = Object.assign([], this.$route.matched);

      itMatched.shift();

      itMatched.forEach((item) => {
        itList.push({
          path: item.path,
          name: item.meta.title,
        });
      });

      itList.forEach((item) => {
        if (item.path === this.$route.path) {
          item.fullPath = this.$route.fullPath;

          this.itBread.forEach((val, key) => {
            if (item.path === val.path) {
              this.itBread.splice(key, 1);
            }
          });

          this.itBread.push(item);
        }
      });

      itList.forEach((item) => {
        if (!item.fullPath) {
          this.itBread.forEach((val) => {
            if (item.path === val.path) {
              item.fullPath = val.fullPath;
            }
          });
        }
      });

      top.postMessage({
        type: 'itGetRoute',
        value: itList,
      }, '*');
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   const url = window.location.origin;
  //   const reg = new RegExp('(^|&)access_token=([^&]*)(&|$)');
  //   const result = to.hash.substr(1).match(reg);
  //   const access_token = result ? decodeURIComponent(result[2]) : null;
  //   if (access_token) {
  //     localStorage.setItem('token', access_token);
  //     next();
  //   } else if (!token.get()) {
  //     // window.location.href = `https://ucenter.yunkedun.com/oauth/authorize?client_id=4&redirect_uri=${url}&response_type=token&scope=&state=auto`;
  //   } else {
  //     next();
  //   }
  // },
};
</script>

<style lang="scss" scoped>
.main {
  background: rgb(240, 242, 245);
  .el-main {
    padding: 0;
  }
  .main-content {
    display: flex;
    flex: auto;
    flex-direction: column;
    padding-bottom: 2em;
    min-height: 100vh;
    overflow-x: hidden;
    .main-body {
      margin: 24px 24px 0;
      background-color: #fff;
      padding: 24px 32px;
      min-height: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/index.vue